/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum profil_change_carac {
  CARAC_GROUND_ADV = 'carac_ground_adv',
  CARAC_GROUND_MAR = 'carac_ground_mar',
  CARAC_FLY_ADV = 'carac_fly_adv',
  CARAC_FLY_MAR = 'carac_fly_mar',
  CARAC_DIS = 'carac_dis',
  CARAC_EVOKED = 'carac_evoked',
  CARAC_HP = 'carac_hp',
  CARAC_DEF = 'carac_def',
  CARAC_RES = 'carac_res',
  CARAC_ARM = 'carac_arm',
  CARAC_AEG = 'carac_aeg',
  CARAC_ATT = 'carac_att',
  CARAC_OF = 'carac_of',
  CARAC_STR = 'carac_str',
  CARAC_AP = 'carac_ap',
  CARAC_AGI = 'carac_agi',
  M = 'M',
  WS = 'WS',
  BS = 'BS',
  S = 'S',
  T = 'T',
  W = 'W',
  I = 'I',
  A = 'A',
  E = 'E',
  LD = 'LD',
}
